module.exports = __webpack_public_path__ + "img/account.f72fb2f7.png";